import React from 'react'
import { Typography, Icon, Row, Col, Collapse, Table, Input, Select, DatePicker, Form, Spin, Result } from 'antd';
import PropTypes from 'prop-types'
import { withApollo } from 'react-apollo'
import { Queries } from '../../../graphql'
import Container from '../../../components/user/Container'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { convertToHTMl } from '../../../utils/markDown'
import { youtubeParser } from '../../../utils/youtube'
import moment, { min } from 'moment';
import { changeFormatdate, changeFormatdateThai, changeFormatMonthYearThai } from '../../../utils/formatdate'
import { checkStatus } from '../../../utils/workHistory'

const { Text, Title } = Typography

const { Panel } = Collapse;
const { Option } = Select;
class workHistory extends React.Component {
    state = {
        loading:true,
        dataTalbe: [],
        dataTalbeAPI: [],
        columns: [
            {
                title: 'ลำดับ',
                dataIndex: 'docId',
                width:'90px',
				align:'center',
                render: (item, record, index) => <span>{ (this.state.pageData.offset+index) + 1}</span>
            },
			{
                title: 'เดือนปี',
				align:'center',
                width:'150px',
                dataIndex: 'dataDate',
                render: (item, record, index) => <span>{ changeFormatdateThai(item) }</span>
            },
            {
                title: 'เลขที่คำสั่ง',
				align:'center',
                width:'150px',
                dataIndex: 'documentNo',
                render: (item, record, index) => <span>{ item }</span>
            },
			{
                title: 'ประเภท',
                width:'200px',
                dataIndex: 'dataType',
                render: (item, record, index) => <span>{ checkStatus(item) }</span>
            },
			{
                title: 'รายละเอียด',
                dataIndex: 'dataMessage',
                render: (item, record, index) => <span>{ item }</span>
            },
            {
                title: 'แหล่งที่มา',
                dataIndex: '7',
                width:'100px',
				align:'center',
                dataIndex:'sourceDb',
                render: (item, record, index) => <span className={ item == 'HRMI' ? 'color-workHistory-gree' : 'color-workHistory-red' }>{ item }</span>

            },
        ],
        pageData: {
            offset: 0,
            limit: 10
        },
        pagination: {
            total: 10,
        },
        disabledDateStart:null,
        endStartValues:null,
        dataTalbe:null,
        dataType: null,
        startDate: null,
        endDate: null,
        searchText: null,
        preLoadsShowForm: true,
        checkShowFormWorkHistory:true,
        currentPage: 1
    }

    fetchEmployeeProfileHistory = async(dataType, startDate, endDate, searchText) =>{
        console.log('dataType',dataType)
        try {
			const { client, location } = this.props
            console.log('startDate',startDate)
			const { data, errors } = await client.query({
				query: Queries.fetchEmployeeProfileHistory,
                variables: {
                    dataType,
                    // startDate: startDate ? startDate : null,
                    // endDate: endDate ? endDate : null,
                    // search: searchText
                }
			})

            await this.setState({
                pageData: {
                    offset: 0,
                    limit: 10
                },
                currentPage: 1
            })

            // console.log('data.fetchEmployeeProfileHistory', data.fetchEmployeeProfileHistory)

            if(data.fetchEmployeeProfileHistory){
                if(searchText){
                    await this.setState({
                        dataTalbeAPI: data.fetchEmployeeProfileHistory,
                        loading:false
                    })
                    await this.onSearchInput(searchText)
                }else{
                    await this.setState({
                        dataTalbe: data.fetchEmployeeProfileHistory,
                        dataTalbeAPI: data.fetchEmployeeProfileHistory,
                        loading:false
                    })
                }
                
            }
			
		} catch (error) {
            await this.setState({
                loading:false
            })
			// const errorMessage = error.graphQLErrors[0].message
			// message.error("Token is expired.")
		}
    }

    onChangeValueDateStart = async (valueDateStart) =>{
        const { dataType, startDate, endDate, searchText } = this.state
		await this.setState({
			 disabledDateStart: moment(valueDateStart),
		})
	}

	onChangeValueDateEnd = async (valueDateEnd) =>{
        const { dataType, startDate, endDate, searchText } = this.state

		await this.setState({
			endDate: moment(valueDateEnd),
		})

        await this.fetchEmployeeProfileHistory(dataType, startDate, valueDateEnd, searchText)
	}

    onSearchInput = async (valueSearch) =>{
        const { dataType, startDate, endDate, searchText, dataTalbeAPI } = this.state

        await this.setState({
            searchText: valueSearch
        })

        const dataTalbe = []

        dataTalbeAPI.filter(data => data.dataMessage.includes(valueSearch)).map(dataSearch => {
            dataTalbe.push(dataSearch)
        })

        // console.log(dataTalbe)

        await this.setState({
            dataTalbe
        })
        // await this.fetchEmployeeProfileHistory(dataType, startDate, endDate, valueSearch)
    }

    filterType = async(filterType) =>{
        const { dataType, startDate, endDate, searchText } = this.state
        await this.setState({
            dataType: filterType
        })
        await this.fetchEmployeeProfileHistory(filterType, startDate, endDate, searchText)
    }

    disabledDate = (current) =>{
        const { disabledDateStart } = this.state
        return current && current < disabledDateStart;
    }

    paginationChange = async e => {
		let offset = 0;
		if (e.current === 1) {
			offset = 0
		} else {
			offset = e.current - 1 + "0"
		}

		await this.setState({
			pageData: {
				offset: parseInt(offset),
				limit: 10
			},
            currentPage: e.current
		})
	}

    checkIsEmployeeProfileHistoryActive = async () =>{
        try {
			const { client, location } = this.props
			const { data, errors } = await client.query({
				query: Queries.checkIsEmployeeProfileHistoryActive,
			})

            await this.setState({
                checkShowFormWorkHistory: data.checkIsEmployeeProfileHistoryActive.status,
                preLoadsShowForm: false
            })

		} catch (error) {
           
		}
    }

    componentDidMount = async () => {
        await this.checkIsEmployeeProfileHistoryActive()
        await this.fetchEmployeeProfileHistory("ALL",null,null,null)
    }

    render() {
        const { match } = this.props
		const { getFieldDecorator } = this.props.form;
        const { dataTalbe, columns, loading, disabledDateStart, endStartValues, checkShowFormWorkHistory, preLoadsShowForm, currentPage } = this.state
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {/* {
                    checkShowFormWorkHistory
                } */}
                <Spin spinning={preLoadsShowForm} delay={500}>
                    <div id="page-workHistory">
                        {
                            !checkShowFormWorkHistory &&
                            <div
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        padding: '16px 32px',
                                        backgroundColor: '#fff',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Result
                                        status="404"
                                        title="ขออภัย"
                                        subTitle="กำลังอยู่ระหว่างการปรับปรุงข้อมูล"
                                    />
                                </div>
                            ||
                            <>
                                <Form >
                                    <Row gutter={16} type="flex" justify="left" align="top">
                                        <Col md={6} className="mb-3">
                                            <Input.Search
                                                placeholder="ค้นหา"
                                                onChange={ (e) => this.onSearchInput(e.target.value) }
                                                style={{ width: "100%" }}
                                            />
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            <Select 
                                                defaultValue="ประวัติทั้งหมด" 
                                                style={{ width: "100%" }} 
                                                onChange={ this.filterType } 
                                                className="selectType"
                                            >
                                                <Option value="ALL">ประวัติทั้งหมด</Option>
                                                <Option value="Salary">ประวัติการปรับเงินเดือน</Option>
                                                <Option value="Position">ประวัติการดำรงตำแหน่ง</Option>
                                                <Option value="Education">ประวัติการศึกษา</Option>
                                                <Option value="Coin">ประวัติการรับเหรียญกาชาด</Option>
                                                <Option value="Decor">ประวัติการรับเครื่องราชอิสริยาภรณ์</Option>
                                            </Select>
                                        </Col>
                                        {/* <Col md={6} className="mb-3">
                                            { getFieldDecorator('startDate', {
                                                initialValue: disabledDateStart,
                                                rules:  [{ 
                                                    required:false,
                                                }],
                                            })(
                                                <DatePicker 
                                                    style={{ width:"100%" }} 
                                                    placeholder="เลือกวันที่เริ่มต้น " 
                                                    onChange={(e) => this.onChangeValueDateStart(e)}
                                                    allowClear={false}
                                                    className="dateStyle"
                                                />
                                            )}
                                        </Col>
                                        <Col md={6} className="mb-3">
                                            { getFieldDecorator('endDate', {
                                                initialValue: endStartValues,
                                                rules:  [{ 
                                                    required:false,
                                                }],
                                            })(
                                                <DatePicker 
                                                    disabledDate={this.disabledDate} 
                                                    disabled={ disabledDateStart ? false : true }
                                                    style={{ width:"100%" }}
                                                    // defaultValue={ valuesEndDate ? moment(valuesEndDate) : '' } 
                                                    placeholder="เลือกวันที่สิ้นสุด"
                                                    onChange={(e) => this.onChangeValueDateEnd(e)}
                                                    allowClear={false}
                                                    className="dateStyle"
                                                />
                                            )}
                                        </Col> */}
                                    </Row>
                                </Form>

                                <Row gutter={16} type="flex" justify="left" align="top" className="mt-4">
                                    <Col md={24}>
                                        <Table
                                            locale={{ emptyText: 'ไม่พบรายการ' }} 
                                            className="tableCustom-workHistory"
                                            dataSource={dataTalbe} 
                                            columns={columns} 
                                            loading={loading}
                                            scroll={{ x: 240 }}
                                            onChange={this.paginationChange }
                                            pagination={{
                                                current: currentPage
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </>
                        }
                       
                    </div>
                </Spin>
            </Container>
        )
    }
}

workHistory.defaultProps = {
	autoFocus: false
}

workHistory.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedworkHistory = Form.create()(workHistory)

export default withApollo(WrappedworkHistory)